import axios from 'axios';
import cookie from 'react-cookies';
import { FieldTypes, ImageUrlFields, systemDateField } from 'drapcode-constant';
export const methodTypes = [
  { value: 'GET', label: 'GET' },
  { value: 'POST', label: 'POST' },
  { value: 'PUT', label: 'PUT' },
  { value: 'PATCH', label: 'PATCH' },
  { value: 'DELETE', label: 'DELETE' },
];

export const userUtilPaths = [
  { url: '/login', description: `Login with Username and Password` },
  { url: '/signup/send-email-otp', description: `Send OTP to Email for Signup.` },
  { url: '/signup/verify-email-otp', description: `Verify Email OTP for Signup.` },
  { url: '/login/send-email-otp', description: `Send OTP to Email for Login.` },
  { url: '/login/verify-email-otp', description: `Verify Email OTP for Login.` },
  { url: '/signup/send-sms-otp', description: `Send OTP to SMS for Signup.` },
  { url: '/signup/verify-sms-otp', description: `Verify SMS OTP for Signup.` },
  { url: '/login/send-sms-otp', description: `Send OTP to SMS for Login.` },
  { url: '/login/verify-sms-otp', description: `Verify SMS OTP for Login.` },
];

const { uuid, createdBy, isDeleted } = FieldTypes;

export const getDescriptionForCheckbox = (dependency, isChecked) => {
  let description = '';

  switch (dependency) {
    case 'enable':
      description = isChecked
        ? `API is enabled (available for usage)`
        : `API is disabled (unavailable for usage)`;
      break;
    case 'auth':
      description = isChecked ? `Developer API key is required` : `Developer API will be public`;
      break;
    case 'isEncrypted':
      description = isChecked ? `Data will be encrypted` : `Data will be decrypted`;
      break;
    case 'userAuthenticate':
      description = isChecked
        ? `User authentication is required`
        : `User authentication is not required`;
      break;
    default:
      description = '';
      break;
  }

  return description;
};
export const createUtilityPath = (devApis) => {
  const paths = [];
  // Any File to Text
  let method = 'POST';
  let collPath = `/anyFileToText`;
  let finalUniqueKey = `${method}-${collPath}`;
  let urlDescription = `Extract Text from single File`;
  let path = createUtilPath(devApis, method, collPath, finalUniqueKey, urlDescription);
  paths.push(path);

  // Any File to Text Multi
  collPath = `/multi-file/anyFileToText`;
  finalUniqueKey = `${method}-${collPath}`;
  urlDescription = `Extract Text from multiple Files`;
  path = createUtilPath(devApis, method, collPath, finalUniqueKey, urlDescription);
  paths.push(path);

  return paths;
};

const createUtilPath = (devApis, method, collPath, finalUniqueKey, urlDescription) => {
  const devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  return {
    collectionName: 'Utility',
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method,
    uniqueKey: finalUniqueKey,
    url: collPath,
    urlDescription: urlDescription,
  };
};

export const createAllPath = (collection, emailTemplate, devApis) => {
  const { collectionName, collectionTitle, finders, constructors, fields } = collection;
  const paths = [];
  const uniqueKey = `${collectionName}-`;
  const collPath = `/collection/${collectionName}/`;
  devApis = devApis.filter((api) => api.collectionName === collectionName);

  console.log('🚀......collection....🚀', collection);

  //Create Item Path
  let method = 'POST';
  let finalUniqueKey = `${uniqueKey}${method}-${collPath}items`;
  let devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);

  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}items`,
    urlDescription: `Create item of ${collectionTitle}`,
  });

  //GET Item
  method = 'GET';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}items`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);

  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}items`,
    urlDescription: `Get all items of ${collectionTitle}`,
  });
  //Finder Get Item
  method = 'GET_FILTER_ITEMS';
  if (finders && finders.length) {
    finders.forEach((finder) => {
      const finderPath = `filter/${finder.uuid}/items`;
      finalUniqueKey = `${uniqueKey}${method}-${collPath}${finderPath}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `${collPath}${finderPath}`,
        urlDescription: `Get filtered item (${finder.name}) of ${collectionTitle}`,
      });
    });
  }
  //Get item by ids
  method = 'POST_ITEMS_BY_IDS';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}itemsbyids`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}itemsbyids`,
    urlDescription: `Create items by itemsids in ${collectionTitle}`,
  });
  // Get item by id
  method = 'GET_ITEM';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}item/{itemUuid}`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}item/{itemUuid}`,
    urlDescription: `Get item by itemUuid in ${collectionTitle}`,
  });
  // Put item by id
  method = 'PUT_ITEM';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}item/{itemUuid}`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}item/{itemUuid}`,
    urlDescription: `Update item by itemUuid in ${collectionTitle}`,
  });
  // Delete item by id
  method = 'DELETE_ITEM';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}item/{itemUuid}`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}item/{itemUuid}`,
    urlDescription: `Delete item by itemUuid in ${collectionTitle}`,
  });
  // Post bulk
  method = 'POST_BULK_UPLOAD_ITEMS';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}bulk/`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}bulk/`,
    urlDescription: `Create bulk items in ${collectionTitle}`,
  });
  // Post bulk delete
  method = 'POST_BULK_DELETE';
  finalUniqueKey = `${uniqueKey}${method}-${collPath}bulkDelete`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `${collPath}bulkDelete`,
    urlDescription: `Delete bulk items from ${collectionTitle}`,
  });

  //Post constructor
  method = 'POST_ITEMS_CONSTRUCTOR';
  if (constructors && constructors.length) {
    constructors.forEach((constructor) => {
      const finderPath = `items/constructor/${constructor.uuid}`;
      finalUniqueKey = `${uniqueKey}${method}-${collPath}${finderPath}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `${collPath}${finderPath}`,
        urlDescription: `Create item using predefined values (${constructor.customConstructorName}) in ${collectionTitle}`,
      });
    });
  }
  //Upload
  method = 'POST_UPLOAD';
  const fileFields = fields.filter((field) => ImageUrlFields.includes(field.type));
  if (fileFields && fileFields.length) {
    fileFields.forEach((field) => {
      finalUniqueKey = `${uniqueKey}${method}-/upload/${collectionName}/${field.uuid}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `/upload/${collectionName}/${field.fieldName}`,
        urlDescription: `Upload file in ${field.fieldTitle.en} of ${collectionTitle}`,
      });
    });
  }

  const filEmailTemplates = emailTemplate.filter(
    (template) => template.collectionId === collectionName,
  );
  if (filEmailTemplates && filEmailTemplates.length) {
    filEmailTemplates.forEach((template) => {
      method = 'POST_SEND_EMAIL';
      finalUniqueKey = `${uniqueKey}${method}-/sendEmail/${template.uuid}/user/{sendTo}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `/sendEmail/${template.uuid}/user/{sendTo}`,
        urlDescription: `Send Email (${template.name}) to send to.`,
      });
      method = 'POST_SEND_DYNAMIC_EMAIL';
      finalUniqueKey = `${uniqueKey}${method}-/sendDynamicEmail/${template.uuid}/sendToCollection/${collectionName}/item/{collectionItemId}`;
      devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: `/sendDynamicEmail/${template.uuid}/sendToCollection/${collectionName}/item/{collectionItemId}`,
        urlDescription: `Send dynamic content of ${collectionTitle} in mail (${template.name})`,
      });
    });
  }

  if (collectionName === 'user') {
    // Login User
    let method = 'POST';
    userUtilPaths.forEach((path) => {
      let finalUniqueKey = `${uniqueKey}${method}-${path.url}`;
      let devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
      paths.push({
        collectionName,
        auth: devApi ? devApi.auth : false,
        enable: devApi ? devApi.enable : false,
        isEncrypted: devApi ? devApi.isEncrypted : false,
        userAuthenticate: devApi ? devApi.userAuthenticate : false,
        roles: devApi ? devApi.roles : [],
        permissions: devApi ? devApi.permissions : [],
        method: method,
        uniqueKey: finalUniqueKey,
        url: path.url,
        urlDescription: path.description,
      });
    });
  }
  method = 'PUT_FILE_OBJECT';
  finalUniqueKey = `${uniqueKey}${method}-/updateFileObject/fileObjectUuid`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `/updateFileObject/${collectionName}/{fileObjectUuid}`,
    urlDescription: `Update File Object from ${collectionTitle} (query: ?itemUuid={itemUuid}&fieldName={fieldName})`,
  });

  method = 'GET_TYPESENSE_INDEXED_DATA';
  finalUniqueKey = `${uniqueKey}${method}-/typesense-search/get-all-indexed-data`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `/typesense-search/get-all-indexed-data/${collectionName}`,
    urlDescription: `Get all Typesense indexed data for ${collectionTitle} `,
  });

  method = 'GET_FILE_BUFFER';
  finalUniqueKey = `${uniqueKey}${method}-/get-file-buffer/fileObjectUuid`;
  devApi = devApis.find((api) => api.uniqueKey === finalUniqueKey);
  paths.push({
    collectionName,
    auth: devApi ? devApi.auth : false,
    enable: devApi ? devApi.enable : false,
    isEncrypted: devApi ? devApi.isEncrypted : false,
    userAuthenticate: devApi ? devApi.userAuthenticate : false,
    roles: devApi ? devApi.roles : [],
    permissions: devApi ? devApi.permissions : [],
    method: method,
    uniqueKey: finalUniqueKey,
    url: `/get-file-buffer/${collectionName}/{fileObjectUuid}`,
    urlDescription: `Get File Buffer from ${collectionTitle} (query: ?itemUuid={itemUuid}&fieldName={fieldName})`,
  });
  console.log(`########## ${collectionName} ########## DEV-API`);
  return paths;
};

export const apiTypes = [
  { value: 'DATA_SOURCE_API', label: 'Data Source API' },
  { value: 'DEVELOPER_API', label: 'Developer API' },
  { value: 'EXTERNAL_API', label: 'External API' },
  { value: 'WEBHOOK_API', label: 'Webhook API' },
];

export const encryptionTypes = [{ value: 'KMS', label: 'AWS KMS Encryption' }];
export const encryptionAlgorithmTypes = [{ value: 'aes-256-cbc', label: 'AES-256-CBC' }];

export const defaultOption = { id: 1, key: '', value: '' };
export const apiTypeImages = {
  AIRTABLE: 'airtable.svg',
  REST_API: 'rocket.svg',
  DIRECTUS: 'directus.svg',
  DATABASE: 'database.svg',
  INTEGROMAT: 'integromat.svg',
  ZAPIER: 'zapier.svg',
  XANO: 'xano.svg',
  SUPABASE: 'supabase.svg',
  DIRECTUS: 'directus.svg',
  NOTION: 'notion.svg',
  APP_WRITE: 'appwrite.svg',
  XATA: 'xata.svg',
  GOOGLE_SHEET: 'google-sheets.svg',
  FIREBASE_REALTIME_DATABASE: 'firebase-realtime-database.svg',
  FIREBASE_CLOUD_FIRESTORE: 'firebase-cloud-firestore.svg',
  FIREBASE_FUNCTION: 'firebase-cloud-function.svg',
  XATA: 'xata.svg',
  SALESFORCE: 'salesforce.svg',
};

export const headerSuggestions = [
  { text: 'Accept' },
  { text: 'Content-Type' },
  { text: 'Authorization' },
  { text: 'Host' },
];

export const valueSuggestions = [
  { text: 'application/json' },
  { text: 'application/xml' },
  { text: 'text/plain' },
  { text: 'application/atom+xml' },
  { text: 'application/octet-stream' },
];

export const getKeySuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? []
    : headerSuggestions.filter(
        (lang) => lang.text.toLowerCase().slice(0, inputLength) === inputValue,
      );
};

export const getValueSuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  return inputValue.length === 0
    ? []
    : valueSuggestions.filter((lang) => lang.text.toLowerCase().includes(inputValue));
};

export const getSuggestion = (suggestion) => suggestion.text;

const textTypeParams = [
  'startString',
  'endString',
  'separator',
  'expression',
  'numberOfRecords',
  'tableStyle',
  'theadStyle',
  'tbodyStyle',
  'trStyle',
  'tdStyle',
  'thStyle',
];

export const parseUtilityFunctionFormData = (values) => {
  values = filterUtilityData(values);
  const utilityData = { name: '', functionType: '', args: [] };
  Object.keys(values).forEach((key) => {
    if (key === 'functionName') {
      utilityData.name = values.functionName;
    } else if (key === 'methodType') {
      utilityData.functionType = values.methodType.value;
    } else if (key && values[key]) {
      if (values[key] instanceof Array) {
        if (values[key].length === 1) {
          utilityData.args.push({ name: key, key: values[key][0].value });
        } else {
          const fields = [];
          values[key].forEach((key) => fields.push(key.value));
          utilityData.args.push({ name: key, key: fields });
        }
      } else if (
        [
          'whitespace',
          'noSplitopt',
          'length',
          'endopt',
          'startLength',
          'endLength',
          'indexNum',
          'unitToAdd',
        ].includes(key)
      ) {
        utilityData.args.push({ name: key, key: values[key] });
      } else if (textTypeParams.includes(key)) {
        const value = values[key] && values[key].value ? values[key].value : values[key];
        const replacedValue = stringToExpression(value);
        utilityData.args.push({ name: key, key: replacedValue });
      } else if (key === 'currency') {
        const value = values.currency.value[values.displayType.value];
        utilityData.args.push({ name: key, key: value });
      } else {
        utilityData.args.push({ name: key, key: values[key].value });
      }
    }
  });
  return utilityData;
};

const filterUtilityData = (utilityData) => {
  switch (utilityData.methodType.value) {
    case 'AVERAGE':
    case 'MULTIPLY':
    case 'ADDITION':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        numbers: utilityData.numbers,
      };
      break;
    case 'DIVIDE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        numbers1: utilityData.number1,
        numbers2: utilityData.number2,
      };
      break;
    case 'CUSTOM_CALCULATION':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        expression: utilityData.expression,
        formatType: utilityData.formatType,
      };
      break;
    case 'CUSTOM_JAVASCRIPT_LOGIC':
    case 'CUSTOM_SENTENCE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        expression: utilityData.expression,
      };
      break;
    case 'SUBSTRACTION':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        numbers1: utilityData.numbers1,
        numbers2: utilityData.numbers2,
      };
      break;
    case 'CAPITALIZE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        restToLower: utilityData.restToLower,
        subject: utilityData.subject,
      };
      break;
    case 'LOWER_CASE':
    case 'UPPER_CASE':
    case 'SLUGIFY':
    case 'COUNT':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        condition: utilityData.condition,
        refField: utilityData.refField,
        refFieldType: utilityData.refFieldType,
        match: utilityData.match,
      };
      break;
    case 'PERCENTAGE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        condition: utilityData.condition,
        refField: utilityData.refField,
        refFieldType: utilityData.refFieldType,
        match: utilityData.match,
        formatType: utilityData.formatType,
      };
    case 'FIND_RECORD':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        refField: utilityData.refField,
        record: utilityData.record,
        index: utilityData.index,
      };
      break;
    case 'TRIM':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        whitespace: utilityData.whitespace,
        type: utilityData.type,
      };
      break;
    case 'TITLE_CASE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        noSplitopt: utilityData.noSplitopt,
      };
      break;
    case 'TRUNCATE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        length: utilityData.length,
        endopt: utilityData.endopt,
      };
      break;
    case 'SUB_STRING':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        startLength: utilityData.startLength,
        endLength: utilityData.endLength,
      };
      break;
    case 'STRING_JOIN':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        textFields: utilityData.textFields,
        startString: utilityData.startString,
        endString: utilityData.endString,
        separator: utilityData.separator,
      };
      break;
    case 'SPLIT_STRING':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        separator: utilityData.separator,
        index: utilityData.index,
        indexNum: utilityData.indexNum,
      };
      break;
    case 'FORMAT_DATE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        datentime: utilityData.datentime,
        unixType: utilityData.unixType ? utilityData.unixType : '',
      };
      break;
    case 'CURRENCY_FORMAT':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        subject: utilityData.subject,
        currency: utilityData.currency,
        position: utilityData.position,
        displayType: utilityData.displayType,
        maxFraction: utilityData.maxFraction,
      };
      break;
    case 'DATE_DIFFERENCE':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        formatType: utilityData.formatType,
        datentime1: utilityData.datentime1,
        datentime2: utilityData.datentime2,
      };
      break;
    case 'DATE_ADD':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        datentime1: utilityData.datentime1,
        formatType: utilityData.formatType,
        unitToAdd: utilityData.unitToAdd,
        unitTypeToAdd: utilityData.unitTypeToAdd,
      };
      break;
    case 'BEAUTIFY_LIST':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        positionOfRecords: utilityData.positionOfRecords,
        numberOfRecords: utilityData.numberOfRecords,
        elementToRender: utilityData.elementToRender,
      };
      break;
    case 'URL_PARAMETERS':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        type: utilityData.type,
        field: utilityData.field,
      };
      break;
    case 'MARKDOWN_TO_HTML':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
      };
      break;
    case 'TABLE_FORMAT':
      return {
        functionName: utilityData.functionName,
        methodType: utilityData.methodType,
        subject: utilityData.subject,
        tableRefernceFields: utilityData.tableRefernceFields,
        tableStyle: utilityData.tableStyle,
        theadStyle: utilityData.theadStyle,
        tbodyStyle: utilityData.tbodyStyle,
        trStyle: utilityData.trStyle,
        tdStyle: utilityData.tdStyle,
        thStyle: utilityData.thStyle,
      };
      break;
    default:
      return {};
  }
};

export const dynamicSort = (property) => {
  return (a, b) => {
    const result =
      !a[property] || !b[property]
        ? 0
        : a[property].toLowerCase() < b[property].toLowerCase()
        ? -1
        : a[property].toLowerCase() > b[property].toLowerCase()
        ? 1
        : 0;
    return result;
  };
};

export const snakeCaseToTitleCase = (str, checkForUnderscore = false) => {
  if (!str) return str;
  if (typeof str === 'string' && !checkForUnderscore) {
    return str
      .toLowerCase()
      .split('_')
      .map((word) => {
        return word.replace(word[0], word[0].toUpperCase());
      })
      .join(' ');
  }
  return str;
};

export const constantCaseToUpperCase = (str) => {
  if (!str) return str;
  if (typeof str === 'string') {
    return str
      .toLowerCase()
      .split('_')
      .map((word) => {
        return word.toUpperCase();
      })
      .join(' ');
  }
  return str;
};

export const camelCaseToTitleCase = (str) => {
  if (!str) return str;
  if (typeof str === 'string') {
    const result = str.replace(/([A-Z])/g, ' $1');
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
  }
  return str;
};

export const moveDefaultCollectionFieldsToEndAndSort = (fields, excludeRefField = false) => {
  const defaultFields = [];
  const customFields = [];
  fields.map((element) => {
    if ([uuid.id, ...systemDateField, createdBy.id].includes(element.fieldName)) {
      defaultFields.push(element);
    } else if (element.fieldName === isDeleted.id) {
    } else if (excludeRefField && ['reference'].includes(element.type)) {
    } else {
      customFields.push(element);
    }
  });
  return [
    ...customFields.sort(dynamicSort('fieldName')),
    ...defaultFields.sort(dynamicSort('fieldName')),
  ];
};

export const tabNameToTitle = (tab) => {
  switch (tab) {
    case 'appConstant':
      return 'App Constants';
    case 'appConfig':
      return 'App Settings';
    case 'pageSetting':
      return 'Page Settings';
    case 'robots':
      return 'Robots.txt';
    case 'pwaConfig':
      return 'PWA Configuration';
    case 'customCSS':
      return 'Custom CSS';
    case 'customJS':
      return 'Custom JavaScript';
    case 'pageSnapshot':
      return 'Page Snapshots';
    case 'collectionSnapshot':
      return 'Collection Snapshots';
    case 'snippetShapshot':
      return 'Snippet Snapshots';
    case 'dbExport':
      return 'Database Export';
    case 'devKey':
      return 'Developer API';
    case 'system-activity':
      return 'System Activity';
    case 'publish-activity':
      return 'Publish Activity';
    case 'js-update-page':
      return 'Page Custom JS';
    case 'sitemapXml':
      return 'Sitemap.xml';
    case 'typographyColours':
      return 'Typography & Colours';
    case 'aiModelConfig':
      return 'AI Model Configuration';
    case 'loaderScreen':
      return 'Loader Screen';
    default:
      return camelCaseToTitleCase(tab);
  }
};

export const tabs = [
  'pwaConfig',
  'customCSS',
  'customJS',
  'codeExport',
  'devKey',
  'dbExport',
  'customTheme',
  'encryption',
  'appConfig',
  'localization',
  'version',
  'pages',
  'profiler',
  'notificationSetting',
  'environment',
  'robots',
  'loadingIcon',
  'appConstant',
  'pageSetting',
  'pageSnapshot',
  'snippetShapshot',
  'system-activity',
  'publish-activity',
  'resources',
  'collectionSnapshot',
  'customFonts',
  'sitemapXml',
  'globalTheme',
  'typographyColours',
  'aiModelConfig',
];

export const menuKeys = [
  'appConstant',
  'appConfig',
  'pageSetting',
  'loadingIcon',
  'robots',
  'environment',
  'pwaConfig',
  'codeExport',
  'devKey',
  'dbExport',
  'encryption',
  'localization',
  'version',
  'pages',
  'profiler',
  'publish-activity',
  'resources',
  'system-activity',
  'Delete Permissions',
  'sitemapXml',
  'notificationSetting',
];

export const checkTabName = (pathName) => {
  console.log('pathName app-setting', pathName);
  if (pathName.endsWith('pwaConfig')) return 'pwaConfig';
  if (pathName.endsWith('customCSS')) return 'customCSS';
  if (pathName.endsWith('customJS')) return 'customJS';
  if (pathName.endsWith('customTheme')) return 'customTheme';
  if (pathName.endsWith('customFonts')) return 'customFonts';
  if (pathName.endsWith('codeExport')) return 'codeExport';
  if (pathName.endsWith('devKey')) return 'devKey';
  if (pathName.endsWith('dbExport')) return 'dbExport';
  if (pathName.endsWith('encryption')) return 'encryption';
  if (pathName.endsWith('localization')) return 'localization';
  if (pathName.endsWith('customComponent')) return 'customComponent';
  if (pathName.endsWith('version')) return 'version';
  if (pathName.endsWith('profiler')) return 'profiler';
  if (pathName.endsWith('pages')) return 'pages';
  if (pathName.endsWith('notificationSetting')) return 'notificationSetting';
  if (pathName.endsWith('environment')) return 'environment';
  if (pathName.endsWith('robots')) return 'robots';
  if (pathName.endsWith('loadingIcon')) return 'loadingIcon';
  if (pathName.endsWith('pageSetting')) return 'pageSetting';
  if (pathName.endsWith('appConstant')) return 'appConstant';
  if (pathName.endsWith('appConfig')) return 'appConfig';
  if (pathName.endsWith('pageSnapshot')) return 'pageSnapshot';
  if (pathName.endsWith('snippetShapshot')) return 'snippetShapshot';
  if (pathName.endsWith('system-activity')) return 'system-activity';
  if (pathName.endsWith('publish-activity')) return 'publish-activity';
  if (pathName.endsWith('resources')) return 'resources';
  if (pathName.endsWith('collectionSnapshot')) return 'collectionSnapshot';
  if (pathName.endsWith('sitemapXml')) return 'sitemapXml';
  if (pathName.endsWith('globalTheme')) return 'globalTheme';
  if (pathName.endsWith('typographyColours')) return 'typographyColours';
  if (pathName.endsWith('aiModelConfig')) return 'aiModelConfig';
};

export const expressionToString = (ex) => {
  return ex
    .replace(/##@@##@@##/g, ' ')
    .replace(/##@@##@@@@/g, '>')
    .replace(/@@@@##@@@@/g, '<')
    .replace(/U\+0022/g, '"')
    .replace(/U\+0027/g, "'")
    .replace(/U\+000A/g, '\n');
};

const stringToExpression = (str) => {
  return str
    .replace(/ /g, '##@@##@@##')
    .replace(/>/g, '##@@##@@@@')
    .replace(/</g, '@@@@##@@@@')
    .replace(/\n/g, 'U+000A')
    .replace(/"/g, 'U+0022')
    .replace(/'/g, 'U+0027');
};

export const awsRegion = [
  { label: 'US East (Ohio)', value: 'us-east-2' },
  { label: 'US East (N. Virginia)', value: 'us-east-1' },
  { label: 'US West (N. California)', value: 'us-west-1' },
  { label: 'US West (Oregon)', value: 'us-west-2' },
  { label: 'Africa (Cape Town)', value: 'af-south-1' },
  { label: 'Asia Pacific (Hong Kong)', value: 'ap-east-1' },
  { label: 'Asia Pacific (Mumbai)', value: 'ap-south-1' },
  { label: 'Asia Pacific (Osaka-Local)', value: 'ap-northeast-3' },
  { label: 'Asia Pacific (Seoul)', value: 'ap-northeast-2' },
  { label: 'Asia Pacific (Singapore)', value: 'ap-southeast-1' },
  { label: 'Asia Pacific (Sydney)', value: 'ap-southeast-2' },
  { label: 'Asia Pacific (Tokyo)', value: 'ap-northeast-1' },
  { label: 'Canada (Central)', value: 'ca-central-1' },
  { label: 'China (Beijing)', value: 'cn-north-1' },
  { label: 'China (Ningxia)', value: 'cn-northwest-1' },
  { label: 'Europe (Frankfurt)', value: 'eu-central-1' },
  { label: 'Europe (Ireland)', value: 'eu-west-1' },
  { label: 'Europe (London)', value: 'eu-west-2' },
  { label: 'Europe (Milan)', value: 'eu-south-1' },
  { label: 'Europe (Paris)', value: 'eu-west-3' },
  { label: 'Europe (Stockholm)', value: 'eu-north-1' },
  { label: 'Middle East (Bahrain)', value: 'me-south-1' },
  { label: 'South America (São Paulo)', value: 'sa-east-1' },
];

export const labelForFunctionMethod = (key) => {
  let label = '';
  switch (key) {
    case 'COUNT':
      label = 'Data - Count of Records';
      break;
    case 'FIND_RECORD':
      label = 'Data - Find Specific Record';
      break;
    case 'PERCENTAGE':
      label = 'Data - Percentage (%) of Records';
      break;
    case 'FORMAT_DATE':
      label = snakeCaseToTitleCase('DATE_FORMAT');
      break;
    case 'URL_PARAMETERS':
      label = 'URL Parameters';
      break;
    case 'MARKDOWN_TO_HTML':
      label = 'Markdown to HTML';
      break;
    default:
      label = snakeCaseToTitleCase(key);
      break;
  }
  return label;
};

export const updateUserIpInCookie = async () => {
  try {
    const expires = new Date(Date.now() + 86400000);
    const apiData = await axios.get(`https://api.ipify.org/?format=json`);
    const publicIp = apiData.data.ip;
    cookie.save('userIp', publicIp, { expires });
    return publicIp;
  } catch (error) {
    console.error('An error occurred:', error);
    return null;
  }
};

export const formatJsonBody = (jsonData) => {
  const { body, collectionParamsValue } = jsonData;

  const dataObject = {};
  body.data.forEach((item) => {
    dataObject[item.key] = item.value;
  });

  const transformedData = {
    documentId: '',
    permissions: ['read("any")'],
    data: {
      ...dataObject,
      ...collectionParamsValue,
    },
  };

  return transformedData;
};

export const formatJsonForPatch = (inputData) => {
  inputData.url = inputData.url.replace(
    '{{_data_source_rest_api_primary_id}}',
    inputData.collectionParamsValue['_data_source_rest_api_primary_id'],
  );

  const convertArrayToObject = (inputArray) => {
    const resultObject = {};

    inputArray.forEach((item) => {
      if (item.key !== '_data_source_rest_api_primary_id') {
        resultObject[item.key] = item.value;
      }
    });

    return resultObject;
  };

  inputData.body = { data: convertArrayToObject(inputData.body.data) };

  delete inputData.body.type;
  delete inputData.body.requestType;

  return inputData;
};

export const formatCollectionAndFieldName = (str) => {
  let updateString = cleanCollectionAndFieldName(str);
  return clearSpaceAndReformat(updateString.trim(), '_');
};
export const cleanCollectionAndFieldName = (str) => {
  str = str.replace(/[^a-zA-Z0-9 ]/, '');
  return str;
};
export const clearSpaceAndReformat = (text, separator) => {
  if (!text) {
    return '';
  }
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, separator ? separator : '');
};
export const themeNames = [
  'cerulean',
  'cosmo',
  'cyborg',
  'darkly',
  'flatly',
  'journal',
  'litera',
  'lumen',
  'lux',
  'materia',
  'minty',
  'morph',
  'pulse',
  'quartz',
  'sandstone',
  'simplex',
  'sketchy',
  'slate',
  'solar',
  'spacelab',
  'superhero',
  'united',
  'vapor',
  'yeti',
  'zephyr',
];
export const convertConstantCaseToTitleCase = (str, commaSeparatedException = '') => {
  if (!str) return str;
  const overrideMap = {
    CLAUDE_AI: 'Anthropic AI',
  };
  if (overrideMap[str]) {
    return overrideMap[str];
  }
  const exceptions = commaSeparatedException ? commaSeparatedException.split(',') : [];
  if (typeof str === 'string') {
    return str
      .split('_')
      .map((word) => {
        return exceptions && exceptions.includes(word)
          ? word
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  }
  return str;
};

export const menuItemsForAppConstant = [
  { key: 'appConstant', label: 'App Constants', icon: 'appConstant' },
  { key: 'app-config', label: 'App Settings', icon: 'appConfig' },
  { key: 'pwa-config', label: 'PWA Configuration', icon: 'pwa', requiresProjectDetail: true },
  { key: 'pageSetting', label: 'Page Settings', icon: 'pageSettings' },
  { key: 'robots', label: 'Robots.txt', icon: 'robotTxt', requiresProjectDetail: true },
  { key: 'sitemapXml', label: 'Sitemap.xml', icon: 'sitemapXml', requiresProjectDetail: true },
  { key: 'environment', label: 'Environment', icon: 'environment' },
  { key: 'devKey', label: 'Developer API', icon: 'devKey', requiresProjectDetail: true },
  {
    key: 'encryption-section',
    label: 'Data Encryption',
    icon: 'encryption',
    requiresProjectDetail: true,
  },
  { key: 'version', label: 'Project Version', icon: 'version' },

  {
    key: 'localization-section',
    label: 'Localization',
    icon: 'localization',
    requiresProjectDetail: true,
  },
  {
    key: 'resources',
    label: 'Resources',
    icon: 'webconnect-cloud-arrow-up',
    requiresProjectDetail: true,
    directIcon: true,
  },
];

export const menuItemsForSnapshot = [
  { key: 'pageSnapshot', label: 'Page Snapshots', icon: 'pageSnapshots' },
  { key: 'snippetShapshot', label: 'Snippet Snapshots', icon: 'snippetSnapshots' },
  { key: 'collectionSnapshot', label: 'Collection Snapshots', icon: 'collection' },
];
export const menuItemsForActivity = [
  { key: 'system-activity', label: 'System Activity', icon: 'webconnect-cpu', directIcon: true },
  {
    key: 'publish-activity',
    label: 'Publish Activity',
    icon: 'webconnect-paper-plane',
    directIcon: true,
  },
  { key: 'profiler-section', label: 'Profiler', icon: 'profiler' },
];
export const menuItemsForCustomCssJs = [
  { key: 'custom-css', label: 'Custom CSS', icon: 'customCSS' },
  { key: 'custom-js', label: 'Custom JavaScript', icon: 'customJS' },
  { key: 'custom-theme', label: 'Custom HTML Theme', icon: 'customTheme' },
  { key: 'customFonts', label: 'Custom Fonts', icon: 'customFonts' },
  { key: 'globalTheme', label: 'Global Theme', icon: 'drapcode-icons' },
  { key: 'typographyColours', label: 'Typography & Colours', icon: 'typographyColours' },
  {
    key: 'notificationSetting',
    label: 'Notification Settings',
    icon: 'notification',
  },
  { key: 'loadingIcon', label: 'Loading Icon', icon: 'loadingIcon' },
  { key: 'loader-screen', label: 'Loader Screen', icon: 'loaderScreen' },
];
export const menuItemsForCustomComp = [
  { key: 'customComponent', label: 'Custom Component', icon: 'customComponent' },
  { key: 'customDataMapping', label: 'Custom Data Mapping', icon: 'customDataMapping' },
  { key: 'customFunction', label: 'Custom Function', icon: 'customFunction' },
];
export const menuItemsForAIModel = [
  {
    key: 'aiModelConfig-section',
    icon: 'aiModelConfig',
    label: 'AI Model Configuration',
  },
  {
    key: 'figmaConfig-section',
    icon: 'figmaConfig',
    label: 'Import From Figma',
  },
];  

export const getAppSettingBasePath = (key, version, projectId) =>
  `/app-setting/${version}/v/${projectId}/setting/${key}`;

export const isAppSettingActive = (pathname, key, version, projectId) =>
  pathname.startsWith(getAppSettingBasePath(key, version, projectId));

export const isDeletePermissionActive = (pathname, version, projectId) =>
  pathname.startsWith(`/permission/${version}/v/${projectId}`);
